import { render, staticRenderFns } from "./OfflineUnavailableNotice.vue?vue&type=template&id=8399cba8&scoped=true"
import script from "./OfflineUnavailableNotice.vue?vue&type=script&lang=js"
export * from "./OfflineUnavailableNotice.vue?vue&type=script&lang=js"
import style0 from "./OfflineUnavailableNotice.vue?vue&type=style&index=0&id=8399cba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8399cba8",
  null
  
)

export default component.exports